import React from 'react';

import { UiKit } from 'components';
import * as ExchangesConfig from './ExchangesConfig';
import { FeatureContainer } from '../../components';
import { useFTUWizard } from '../../context';

export default function Exchanges() {
  const { onGotoNext } = useFTUWizard();

  return (
    <FeatureContainer
      title="Do you offer exchanges?"
      subtitle="Select if you'd like to include exchanges to create a more flexible return experience and retain more revenue."
    >
      <ExchangesConfig.Provider>
        <UiKit.Sheet.ActionsPortal>
          <ExchangesConfig.SaveButton onDone={onGotoNext} />
        </UiKit.Sheet.ActionsPortal>
      </ExchangesConfig.Provider>
    </FeatureContainer>
  );
}
